/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/

import * as React from 'react';

import { CategoryHierarchy } from '@msdyn365-commerce/commerce-entities';
import { IGridSettings } from '@msdyn365-commerce/core-internal';
import { searchByCategoryAsync } from '@msdyn365-commerce/retail-proxy/dist/DataActions/ProductsDataActions.g';

import { IEcommProductSliderData } from './ecomm-product-slider.data';
import { IEcommProductSliderProps } from './ecomm-product-slider.props.autogenerated';

export interface IEcommProductSliderViewProps extends IEcommProductSliderProps<IEcommProductSliderData> {
  indexes: number[];
  parentCategoryId: number;
  subCategories: CategoryHierarchy[];
  gridSettings: IGridSettings;
}

/**
 *
 * EcommProductSlider component
 * @extends {React.PureComponent<IEcommProductSliderProps<IEcommProductSliderData>>}
 */
class EcommProductSlider extends React.PureComponent<IEcommProductSliderProps<IEcommProductSliderData>> {
  private _indexes: number[] =[];

  public render(): JSX.Element | null {
    const { data: { hierarchy }, config } = this.props;

    let parentCategoryId = 0;

    if (hierarchy && hierarchy.result) {
      const result = hierarchy.result.find(item => item.Name === config.categoryName)?.RecordId;

      parentCategoryId = result ? result : 0;
    }

    const EcommProductSliderViewProps = {
      ...this.props,
      indexes: this._indexes,
      parentCategoryId: parentCategoryId,
      subCategories: this._getChildCategories()
    };

    return this.props.renderView(EcommProductSliderViewProps);
  }

  private _getChildCategories(): CategoryHierarchy[] {
    const { data: { hierarchy }, config, context } = this.props;

    const result: CategoryHierarchy[] = [];

    if (hierarchy && hierarchy.result) {
      hierarchy.result.forEach(item => {
        // Quick links level e.g. offerings, donations etc.
        if (item.Name?.toLowerCase() === config.categoryName?.toLowerCase()) {
          if (item.Children) {
            // Sub categories under a quick link level e.g. halls.
            item.Children.forEach((child: CategoryHierarchy) => {
              searchByCategoryAsync({ callerContext: context.actionContext }, context.request.apiSettings.channelId, context.request.apiSettings.catalogId, child.RecordId)
              .then(products => {
                if (products && products.length > 0) {  
                  if (this._indexes.length === 0) {
                    this._indexes.push(0);
                  } else {
                    this._indexes.push(this._indexes[this._indexes.length - 1] + products.length);
                  }
                }
              });
  
              result.push(child)
            });
          }
        }
      });
    }

    return result;
  }
}

export default EcommProductSlider;
